import { formStoreLenses } from 'root/src/client/logic/form/lenses'

const { pathOrFormToggles } = formStoreLenses

export default (state, { moduleKey }) => pathOrFormToggles(moduleKey, {}, state)
